import { useState } from 'react';
import SimpleInput from 'ui/input';
import { Select } from 'antd';
import { useGetNaimixLegalEntitiesQuery } from 'pages/facility/api/queries/generated/GetNaimixLegalEntities';
import { useParams } from 'react-router';
interface HrmsSectionProps {
  values: any;
  touched: any;
  errors: any;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  setFieldValue: (field: string, value: any) => void;
  isFieldInherited: (fieldName: string) => boolean;
}

const HrmsSection = ({ values, touched, errors, handleChange, setFieldValue, isFieldInherited }: HrmsSectionProps) => {
  const { facilityId } = useParams();

  const [legalEntitySearch, setLegalEntitySearch] = useState('');

  const { data: legalEntitiesData, fetchMore: fetchMoreLegalEntities } = useGetNaimixLegalEntitiesQuery({
    variables: {
      input: {
        limit: 20,
        offset: 0,
        ...(legalEntitySearch ? { searchQuery: legalEntitySearch } : {}),
      },
    },
  });

  const handleLegalEntityScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const target = e.target as HTMLDivElement;
    const isNearBottom = target.scrollHeight - target.scrollTop <= target.clientHeight + 50;

    if (isNearBottom) {
      fetchMoreLegalEntities({
        variables: {
          input: {
            limit: 20,
            offset: legalEntitiesData?.getNaimixLegalEntities.naimixLegalEntities.length || 0,
            ...(legalEntitySearch ? { searchQuery: legalEntitySearch } : {}),
          },
        },
        updateQuery: (prev, { fetchMoreResult }) => {
          if (!fetchMoreResult) return prev;
          return {
            getNaimixLegalEntities: {
              ...prev.getNaimixLegalEntities,
              naimixLegalEntities: [
                ...prev.getNaimixLegalEntities.naimixLegalEntities,
                ...fetchMoreResult.getNaimixLegalEntities.naimixLegalEntities,
              ],
            },
          };
        },
      });
    }
  };

  return (
    <div className="col-span-full">
      <div className="grid grid-cols-2 gap-5">
        <div>
          <span className="inline-block Subtitle1 text-smena_text-secondary mb-4">Связь с HRMS</span>
          <SimpleInput
            divClassName="w-full"
            label="HRMS ID"
            placeholder="Введите HRMS ID"
            onChange={handleChange}
            value={values.hrmsId || ''}
            type="text"
            name="hrmsId"
            error={touched.hrmsId && errors.hrmsId ? errors.hrmsId : ''}
            disabled={isFieldInherited('hrmsId') || !!facilityId}
          />
        </div>

        <div>
          <span className="inline-block Subtitle1 text-smena_text-secondary mb-4">Связь с Наймикс</span>
          <div className="w-full">
            <label className="label-primary">Юр. лицо</label>
            <Select
              className="w-full"
              showSearch
              placeholder="Выберите юр. лицо"
              optionFilterProp="children"
              onChange={value => setFieldValue('naimixLegalEntityId', value)}
              value={values.naimixLegalEntityId}
              onSearch={value => setLegalEntitySearch(value)}
              filterOption={false}
              onPopupScroll={handleLegalEntityScroll}
              listHeight={200}
              disabled={isFieldInherited('naimixLegalEntityId')}
            >
              {legalEntitiesData?.getNaimixLegalEntities.naimixLegalEntities.map(entity => (
                <Select.Option key={entity.id} value={entity.id}>
                  {entity.name}
                </Select.Option>
              ))}
            </Select>
            {touched.naimixLegalEntityId && errors.naimixLegalEntityId && (
              <div className="error-message">{errors.naimixLegalEntityId}</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HrmsSection;
